import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop';

//Pages Import
import Home from './pages/Home';
import Team from './pages/Team';
import Contact from './elements/contact/Contact';
import Programs from './pages/Programs';
import WieChapt from './pages/WieChapt';
import PesChapt from './pages/PesChapt';
import RasChapt from './pages/RasChapt';
import IasChapt from './pages/IasChapt';
import CsChapt from './pages/CsChapt';
import Profilex from './profiles/Profilex';
import Latest from './pages/Latest';
import notFound from './pages/notFound';
//import css
import './assets/scss/style.scss';
import About from './pages/About';

//import latest things
import CategoryList from './pages/CategoryList';
import DetailedLatest from './pages/DetailedLatest';
import TagList from './pages/TagList';
import Author from './pages/Author';

const App = () => {
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    <Route
                        path={`${process.env.PUBLIC_URL + '/'}`}
                        exact
                        component={Home}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/our-team'}`}
                        exact
                        component={Team}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/contact'}`}
                        exact
                        component={Contact}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/programs'}`}
                        exact
                        component={Programs}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/about-us'}`}
                        exact
                        component={About}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/wie'}`}
                        exact
                        component={WieChapt}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/pes'}`}
                        exact
                        component={PesChapt}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/ras'}`}
                        exact
                        component={RasChapt}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/ias'}`}
                        exact
                        component={IasChapt}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/cs'}`}
                        exact
                        component={CsChapt}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/Profilex'}`}
                        exact
                        component={Profilex}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/our-latest'}`}
                        exact
                        component={Latest}
                    />
                    {/* Our Latest */}
                    <Route
                        path={`${
                            process.env.PUBLIC_URL + '/Latest-details/:id'
                        }`}
                        exact
                        component={DetailedLatest}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/category/:slug'}`}
                        exact
                        component={CategoryList}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/archive/:slug'}`}
                        exact
                        component={Author}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL + '/tag/:slug'}`}
                        exact
                        component={TagList}
                    />
                    {/**Not Found */}
                    <Route
                        path={`${process.env.PUBLIC_URL + '/in-progress'}`}
                        exact
                        component={notFound}
                    />
                </Switch>
            </PageScrollTop>
        </Router>
    );
};

export default App;
